const module_backend_url = '';

export const environment = {
  production: false,
  module_backend_url: module_backend_url,
  cbdx_service: {
    api_path: `${module_backend_url}/api`,
  },
};
